import { FILESPACE_CLIENT_QUERY_KEYS } from '#constants';
const FILESPACE_ENTRY_ID_BASE = FILESPACE_CLIENT_QUERY_KEYS.FilespaceDirectoryId;
export const FilespaceEntryIdKeyFactory = {
    all: () => [FILESPACE_ENTRY_ID_BASE],
    exact: (filespaceId, fsEntryPath) => [
        ...FilespaceEntryIdKeyFactory.all(),
        filespaceId,
        fsEntryPath,
    ],
};
